/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import * as Types from '../../../../../queryTyping';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetBankInfoByRoutingNumberQueryVariables = Types.Exact<{
  routingNumber: Types.Scalars['String'];
  routingNumberType: Types.RoutingNumberType;
  allowOwnFi: Types.Maybe<Types.Scalars['Boolean']>;
}>;


export type GetBankInfoByRoutingNumberQuery = (
  { __typename?: 'Query' }
  & { bankInfoByRoutingNumber: (
    { __typename?: 'GetBankInfoByRoutingNumberResult' }
    & { validationResult: Types.Maybe<(
      { __typename?: 'ValidationResultContainer' }
      & Pick<Types.ValidationResultContainer, 'isSuccess' | 'errorMessages' | 'warningMessages' | 'infoMessages'>
    )>, bankInfo: Types.Maybe<(
      { __typename?: 'BankInfo' }
      & Pick<Types.BankInfo, 'id' | 'routingNumber' | 'routingNumberType' | 'shortName' | 'fullName'>
    )> }
  ) }
);


export const GetBankInfoByRoutingNumberDocument = gql`
    query GetBankInfoByRoutingNumber($routingNumber: String!, $routingNumberType: RoutingNumberType!, $allowOwnFi: Boolean) {
  bankInfoByRoutingNumber(
    routingNumber: $routingNumber
    routingNumberType: $routingNumberType
    allowOwnFi: $allowOwnFi
  ) {
    validationResult {
      isSuccess
      errorMessages
      warningMessages
      infoMessages
    }
    bankInfo {
      id
      routingNumber
      routingNumberType
      shortName
      fullName
    }
  }
}
    `;

/**
 * __useGetBankInfoByRoutingNumberQuery__
 *
 * To run a query within a React component, call `useGetBankInfoByRoutingNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankInfoByRoutingNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankInfoByRoutingNumberQuery({
 *   variables: {
 *      routingNumber: // value for 'routingNumber'
 *      routingNumberType: // value for 'routingNumberType'
 *      allowOwnFi: // value for 'allowOwnFi'
 *   },
 * });
 */
export function useGetBankInfoByRoutingNumberQuery(baseOptions: Apollo.QueryHookOptions<GetBankInfoByRoutingNumberQuery, GetBankInfoByRoutingNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankInfoByRoutingNumberQuery, GetBankInfoByRoutingNumberQueryVariables>(GetBankInfoByRoutingNumberDocument, options);
      }
export function useGetBankInfoByRoutingNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBankInfoByRoutingNumberQuery, GetBankInfoByRoutingNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankInfoByRoutingNumberQuery, GetBankInfoByRoutingNumberQueryVariables>(GetBankInfoByRoutingNumberDocument, options);
        }
export type GetBankInfoByRoutingNumberQueryHookResult = ReturnType<typeof useGetBankInfoByRoutingNumberQuery>;
export type GetBankInfoByRoutingNumberLazyQueryHookResult = ReturnType<typeof useGetBankInfoByRoutingNumberLazyQuery>;
export type GetBankInfoByRoutingNumberQueryResult = Apollo.QueryResult<GetBankInfoByRoutingNumberQuery, GetBankInfoByRoutingNumberQueryVariables>;